import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Parser from "html-react-parser";
import Button from "../shared/button/Button";
import labels from "./labels";
import Saving from "../shared/loaders/Saving";
import ModalThankYou from "../shared/loaders/ModalThankYou";
import {
  DisengageWrapper,
  Modal,
  Title,
  CloseButton,
  Inner,
  Form,
  Label,
  TextInput,
  ButtonsWrapper,
  Field,
  Error,
  CancelButton,
  Note,
  Asterisk,
} from "./styles/recruiter-disengage-form-styles";

const DisengageForm = ({
  formLoading,
  modalActive,
  closeModal,
  handleDisengageSubmit,
  setDisengagementMessage,
  disengagementMessage,
  successMessageActive,
  errors,
}) => (
  <DisengageWrapper className={modalActive && "animated fadeIn"}>
    <Modal className={modalActive && "animated fadeInDown"}>
      <Title>
        Confirm Disengagement
        <CloseButton onClick={() => closeModal()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </Title>
      <Inner>
        {formLoading && <Saving white />}
        {successMessageActive && (
          <ModalThankYou text="Successfuly disengaged" />
        )}
        <Form>
          <Label>{Parser(labels.disengage)}</Label>
          <Field>
            <TextInput
              placeholder="Enter your message..."
              maxLength={300}
              onChange={setDisengagementMessage}
              value={disengagementMessage}
              error={errors}
            />
            {errors && (
              <Error>Message is required (min. of 30 characters.</Error>
            )}
            {disengagementMessage.length < 30 && (
              <Note data-test-id="min-chars-note">
                <Asterisk>*</Asterisk>
                minimum of 30 characters
              </Note>
            )}
            {disengagementMessage.length >= 250 && (
              <Note
                charsLeft
                length={disengagementMessage.length}
                data-test-id="chars-left-note"
              >
                {300 - disengagementMessage.length} characters left
              </Note>
            )}
          </Field>
          <ButtonsWrapper>
            <CancelButton onClick={() => closeModal()} type="button">
              Cancel
            </CancelButton>
            <Button
              primary
              disabled={disengagementMessage.length < 30}
              buttonName="Disengage"
              type="submit"
              onClickAction={(e) => handleDisengageSubmit(e)}
            />
          </ButtonsWrapper>
        </Form>
      </Inner>
    </Modal>
  </DisengageWrapper>
);

DisengageForm.propTypes = {
  errors: PropTypes.shape({
    disengagement_message: PropTypes.string,
  }),
  formLoading: PropTypes.bool.isRequired,
  modalActive: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleDisengageSubmit: PropTypes.func.isRequired,
  setDisengagementMessage: PropTypes.func.isRequired,
  successMessageActive: PropTypes.bool.isRequired,
  disengagementMessage: PropTypes.string.isRequired,
};

DisengageForm.defaultProps = {
  errors: PropTypes.isNull,
};

export default DisengageForm;
